import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SFTP_DOMAIN, MS_SFTP_DOMAIN, MULTISITE_EDITION_NAME } from '../../../globals';
import { SftpKey, SftpKeyService } from '../../core/sftp';
import { Site, SiteService } from '../../core/site';
import { AddKeyDialogComponent } from './add-key.component';
import { DeleteKeyDialogComponent } from './delete-key.component';
import { AccountsService } from '../../accounts.service';

@Component({
  selector: 'app-sftp-key-list',
  templateUrl: './key-list.component.html',
  styleUrls: ['./key-list.styles.scss'],
  standalone: false,
})
export class SftpKeyListComponent implements OnInit, AfterViewInit {
  sftpDomain: string;
  uid: string;
  initialLoading = true;
  keyList: SftpKey[] = [];

  siteUid$: Observable<string>;

  dataSource = new MatTableDataSource();
  displayedColumns = ['name', 'createdBy', 'actions'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private keyService: SftpKeyService,
    private siteService: SiteService,
    private dialog: MatDialog,
    private accountsService: AccountsService,
  ) {}

  ngOnInit(): void {
    this.accountsService.editionName$.subscribe((editionName: string) => {
      if (editionName === MULTISITE_EDITION_NAME) {
        this.sftpDomain = MS_SFTP_DOMAIN;
      } else {
        this.sftpDomain = SFTP_DOMAIN;
      }
    });

    this.siteUid$ = this.siteService.get().pipe(map((site: Site) => site.uid));

    this.keyService.getList().subscribe(
      (sftpKeys) => {
        this.keyList = sftpKeys.keys;
        this.dataSource.data = this.keyList.slice(0, this.paginator.pageSize);
      },
      (err) => console.log(err),
      () => (this.initialLoading = false),
    );
  }

  ngAfterViewInit(): void {
    this.paginator.page.subscribe(
      (pageEvent: PageEvent) => {
        if (!this.initialLoading) {
          const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
          const endIndex = startIndex + pageEvent.pageSize;
          this.dataSource.data = this.keyList.slice(startIndex, endIndex);
        }
      },
      (err) => console.log(err),
    );
  }

  showAddKeyDialog(): void {
    const addKeyDialog = this.dialog.open(AddKeyDialogComponent, {
      disableClose: false,
      hasBackdrop: true,
    });
    addKeyDialog.componentInstance.keyListAdd.subscribe((sftpKey) => {
      this.keyList.push(sftpKey);
      this.keyList.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
      const endIndex = startIndex + this.paginator.pageSize;
      this.dataSource.data = this.keyList.slice(startIndex, endIndex);
    });
  }

  showDeleteKeyDialog(key: SftpKey): void {
    const deleteKeyDialog = this.dialog.open(DeleteKeyDialogComponent, {
      data: { keyName: key.name },
      disableClose: false,
      hasBackdrop: true,
    });

    deleteKeyDialog.afterClosed().subscribe((res) => {
      if (res) {
        this.keyList = this.keyList.filter((item) => item !== key);
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        const endIndex = startIndex + this.paginator.pageSize;
        this.dataSource.data = this.keyList.slice(startIndex, endIndex);
      }
    });
  }
}
